module.exports = __webpack_public_path__ + "src/components/games/assets/linkmo/linkmo.gif";